module.exports = __webpack_public_path__ + "src/img/radioIcon.207eaadc.svg";